import { render, staticRenderFns } from "./NormalQue.vue?vue&type=template&id=be6f45fe&scoped=true"
import script from "./NormalQue.vue?vue&type=script&lang=js"
export * from "./NormalQue.vue?vue&type=script&lang=js"
import style0 from "./NormalQue.vue?vue&type=style&index=0&id=be6f45fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6f45fe",
  null
  
)

export default component.exports